import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import moment from 'moment';
import { CONSTANTS } from '../../../constants/constants';
import { EMPTY_CELL_VALUE } from '../CellComponent/CellComponent';

const DEFAULT_FORMAT = CONSTANTS.DATE_FORMAT.HEADER;

const DateFormatter = ({ value, column }) => {
  const format = column?.dateFormat ?? DEFAULT_FORMAT;
  const parsed = value == null || value === '' ? null : moment(value);
  const formatted = parsed?.isValid() ? parsed.format(format) : EMPTY_CELL_VALUE;
  const dateTime = parsed?.isValid() ? parsed.toISOString() : undefined;

  return (
    <Tooltip title={formatted} placement="top">
      <Typography variant="body2" color="text.primary" component="time" {...(dateTime ? { dateTime } : {})}>
        {formatted}
      </Typography>
    </Tooltip>
  );
};

export const DateProvider = props => <DataTypeProvider formatterComponent={DateFormatter} {...props} />;
